import Image from 'next/image'
import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import {loadImageFromKontentAI} from '@/image-loader'
import type {Block} from '@/services/kontent-ai/types'
import type {
	ImageShapeClasses,
	QuoteBorderClasses,
} from '../../components/quote/quote'
import {Quote} from '../../components/quote/quote'

export type QuoteContentItem = IContentItem<{
	quote: Elements.TextElement
	quotee: Elements.TextElement
	image: Elements.AssetsElement
	imagePlacement: Elements.MultipleChoiceElement
	imageShape: Elements.MultipleChoiceElement
	borderColor: Elements.MultipleChoiceElement
}>

export const QuoteBlock: Block<QuoteContentItem> = ({block}) => {
	const showImageOnTop = block.elements.imagePlacement[0]?.codename === 'top'

	const borderClass = (block.elements.borderColor[0]?.codename ||
		'') as keyof typeof QuoteBorderClasses

	const imageShapeClass = (block.elements.imageShape[0]?.codename ||
		'oval') as keyof typeof ImageShapeClasses

	return (
		<div data-kontent-element-codename="quote">
			<Quote
				borderColor={borderClass}
				image={
					block.elements.image[0] ? (
						<Image
							alt={block.elements.image[0].description || ''}
							className="mx-auto h-44 w-auto rounded-full border-6 border-gray-500"
							height={block.elements.image[0].height || 164}
							loader={loadImageFromKontentAI}
							src={block.elements.image[0].url}
							width={block.elements.image[0].width || 306}
						/>
					) : null
				}
				imageShape={imageShapeClass}
				quote={block.elements.quote}
				quotee={block.elements.quotee}
				showImageOnTop={showImageOnTop}
			/>
		</div>
	)
}
